import { mapMrcGetCp52ToBillData } from '../../pages/BillingAndCollection/MeterReadingCorrection/mrcCp52Api';

/**
 * Map mrc/getCP52 (+ optional CP52 form base with meter readings)
 * into consumer bill fields — same source as CP52 dialog.
 */
export const mapApprovedMrcBillResponse = (apiResponse, options = {}) =>
    mapMrcGetCp52ToBillData(apiResponse, options);
